export type ReportType =
  | "orders_summary"
  | "order_items"
  | "orders_with_items"
  | "payment"
  | "shipping"
  | "customer_orders"
  | "promotion_usage";

export interface ExportReportRequest {
  reportType: ReportType;
  startDate?: string;
  endDate?: string;
  status?: string;
  paymentStatus?: string;
  paymentMethodType?: string;
  cargoCompanyId?: string;
  retailer?: string;
  includeArchived?: boolean;
  includeDeleted?: boolean;
  selectedColumns?: string[];
}

export interface ReportColumn {
  key: string;
  header: string;
}

export interface ReportTypeInfo {
  type: ReportType;
  labelKey: string;
  descriptionKey: string;
  icon: string;
}

export const REPORT_TYPES: ReportTypeInfo[] = [
  {
    type: "orders_summary",
    labelKey: "admin.reports.types.ordersSummary",
    descriptionKey: "admin.reports.types.ordersSummaryDesc",
    icon: "receipt",
  },
  {
    type: "order_items",
    labelKey: "admin.reports.types.orderItems",
    descriptionKey: "admin.reports.types.orderItemsDesc",
    icon: "inventory",
  },
  {
    type: "orders_with_items",
    labelKey: "admin.reports.types.ordersWithItems",
    descriptionKey: "admin.reports.types.ordersWithItemsDesc",
    icon: "table_chart",
  },
  {
    type: "payment",
    labelKey: "admin.reports.types.payment",
    descriptionKey: "admin.reports.types.paymentDesc",
    icon: "payment",
  },
  {
    type: "shipping",
    labelKey: "admin.reports.types.shipping",
    descriptionKey: "admin.reports.types.shippingDesc",
    icon: "local_shipping",
  },
  {
    type: "customer_orders",
    labelKey: "admin.reports.types.customerOrders",
    descriptionKey: "admin.reports.types.customerOrdersDesc",
    icon: "people",
  },
  {
    type: "promotion_usage",
    labelKey: "admin.reports.types.promotionUsage",
    descriptionKey: "admin.reports.types.promotionUsageDesc",
    icon: "local_offer",
  },
];
